<section class="waiting" [style.display]="calendarReady ? 'none' : 'block'">
    <div class="row title">
        <div class="col-xs-6">
            <h4 class="title">{{ 'txWorkflowCalender.pleaseWait' | translate }}</h4>
        </div>
    </div>
    <div class="widget-body">
        <div class="grid">
            <div class="col-12">
                <mat-progress-bar mode="indeterminate"></mat-progress-bar>
                <h6>{{ 'txWorkflowCalender.data' | translate }}</h6>
            </div>
        </div>
    </div>
</section>

<div class="flatcalendar" [style.display]="!calendarReady ? 'none' : 'block'">
    <div *ngIf="WfGroups">
        <div *ngIf="myTabStateService.TabStates$ | async as TabStates">
            <mat-accordion>
                <mat-expansion-panel
                        class="mat-elevation-z0"
                        hideToggle
                        (opened)="onTabOpen('f1')"
                        (closed)="onTabClose('f1')"
                        [expanded]="TabStates.f1 == null || TabStates.f1 == true">
                    <mat-expansion-panel-header>
                        <mat-panel-title>
                            <div class="flex space-x-2">
                                <div class="ml-1">
                                    <div class="transition-all rotate-0 {{ TabStates.f1 ? 'rotate-90' : '' }}">
                                        <fa-icon icon="chevron-right"></fa-icon>
                                    </div>
                                </div>
                                <div class="text-xl font-bold">
                                    {{ 'general.filter' | translate }}
                                </div>
                                <!-- Sits inside mat-panel-title so it stays readable while the panel
                                     is collapsed - otherwise an active filter is invisible. -->
                                <div class="flex items-center text-sm"
                                     [class.font-bold]="activeGroupCount() < WfGroups.length"
                                     [class.text-red-600]="activeGroupCount() < WfGroups.length">
                                    {{ activeGroupCount() }} / {{ WfGroups.length }}
                                </div>
                            </div>
                            <!-- Alle/Keine live in the header row so they take no extra line.
                                 stopPropagation keeps the click from toggling the panel. -->
                            <div class="flex items-center space-x-2 ml-auto mr-2"
                                 *ngIf="WfGroups && WfGroups.length > 0">
                                <button mat-stroked-button class="compact-select-btn"
                                        (click)="$event.stopPropagation(); setAllGroups(true)">
                                    {{ 'general.selectAll' | translate }}
                                </button>
                                <button mat-stroked-button class="compact-select-btn"
                                        (click)="$event.stopPropagation(); setAllGroups(false)">
                                    {{ 'general.selectNone' | translate }}
                                </button>
                            </div>
                        </mat-panel-title>
                    </mat-expansion-panel-header>
                    <div *ngIf="WfGroups && WfGroups.length > 0">
                        <mat-chip-list multiple>
                            <mat-chip
                                    *ngFor="let group of WfGroups"
                                    class="workflow-chip"
                                    [selected]="SelectedGroups.includes(group.id)"
                                    [color]="SelectedGroups.includes(group.id) ? 'primary' : undefined"
                                    (click)="toggleChip(group.id)">
                                {{ group.name }}
                            </mat-chip>
                        </mat-chip-list>
                    </div>
                </mat-expansion-panel>
            </mat-accordion>
        </div>
    </div>
    <div class="grid mb-1" *ngIf="myCalendarHasData">
        <div class="col-12">
            <!-- Kompaktes, einzeiliges Layout mit minimalen Abständen -->
            <div class="flex flex-nowrap align-items-center overflow-x-auto" style="min-height: 42px">
                <!-- Refresh Button -->
                <button mat-mini-fab color="primary" type="button" (click)="refresh()" class="mr-1">
                    <i class="fa fa-sync"></i>
                </button>

                <!-- Today Button -->
                <button *ngIf="myCalendarHasData"
                    (click)="jumpToToday(true)"
                    type="button"
                    mat-raised-button
                    color="primary"
                    class="mr-1 hidden-label">
                    <i class="fa fa-clock mr-1"></i>{{ 'txWorkflowCalender.today' | translate }}
                </button>

                <!-- Load Full Year Button -->
                <button *ngIf="showAllDataLoad"
                    (click)="loadFullYear()"
                    type="button"
                    mat-raised-button
                    color="primary"
                    class="mr-2 hidden-label">
                    <i class="fa fa-calendar mr-1"></i>{{ 'txWorkflowCalender.loadAllData' | translate }}
                </button>
                
                <!-- Trennlinie bei sehr schmalen Bildschirmen (optional) -->
                <span class="mx-auto xs:hidden"></span>
                
                <!-- Items per page toggle group (kompakter) -->
                <div class="ml-auto">
                    <mat-button-toggle-group
                        name="itemsPerPageGroup"
                        [(ngModel)]="itemsPerPage"
                        class="smaller-toggle-group"
                        (change)="persistItemsPerPage()">
                        <mat-button-toggle [value]="10">10</mat-button-toggle>
                        <mat-button-toggle [value]="20">20</mat-button-toggle>
                        <mat-button-toggle [value]="50">50</mat-button-toggle>
                        <mat-button-toggle [value]="9999">{{ 'txWorkflowCalender.all' | translate }}</mat-button-toggle>
                    </mat-button-toggle-group>
                </div>
            </div>
        </div>
    </div>
    <div *ngIf="!myCalendarHasData">{{ 'txWorkflowCalender.noDataAvailable' | translate }}</div>
    <div *ngIf="myCalendarHasData">
        <div class="scheduletable">
            <div class="pinned">
                <table style="table-layout: fixed; width: 100%;">
                    <colgroup>
                        <col class="name-column" [style.width]="TeamLeader ? '40%' : 'calc(100% - 2rem)'">
                        <col *ngIf="TeamLeader" class="info-column-desktop">
                        <col class="status-column-width">
                    </colgroup>
                    <thead>
                    <tr class="month">
                        <th *ngIf="TeamLeader" class="info-column-desktop">&nbsp;</th>
                        <th *ngIf="TeamLeader || !TeamLeader">&nbsp;</th>
                        <th class="w-status-column" style="border-right: 3px solid black !important">&nbsp;</th>
                    </tr>
                    <tr>
                        <th>{{ 'txWorkflowCalender.name' | translate }}</th>
                        <th *ngIf="TeamLeader" class="info-column-desktop">{{ 'txWorkflowCalender.info' | translate }}</th>
                        <th class="w-status-column" style="border-right: 3px solid black !important">
                            <fa-icon icon="sync"
                                     (click)="loadPersonColors()"
                                     [matTooltip]="'txWorkflowCalender.updateStatus' | translate"
                                     matTooltipClass="text-base"
                                     matTooltipPosition="after"></fa-icon>
                        </th>
                    </tr>
                    </thead>
                </table>
                <div class="table-overflow" [style.max-height]="getMaxHeight()">
                    <table id="headerpersons" style="table-layout: fixed; width: 100%;">
                        <colgroup>
                            <col class="name-column" [style.width]="TeamLeader ? '40%' : 'calc(100% - 2rem)'">
                            <col *ngIf="TeamLeader" class="info-column-desktop">
                            <col class="status-column-width">
                        </colgroup>
                        <tbody>
                        <ng-template
                                ngFor
                                let-person
                                [ngForOf]="
									myCalendarRange.persons
										| groupFilter:WfGroups:groupFilterTrigger
								"
                                [ngForTrackBy]="trackByFn">
                            <tr [ngClass]="{ 'with-info-field': TeamLeader }">
                                <td *ngIf="TeamLeader" [matTooltip]="person.name" matTooltipPosition="above"
                                    [matTooltipShowDelay]="1000">
                                    <ng-template [ngIf]="checkCurrentUser(person.personalnr)">
                                        <div class="overflow-hidden font-bold text-nowrap text-overflow-ellipsis">
                                            <a routerLink="/kalender">
                                                {{ person.name }}
                                            </a>
                                        </div>
                                    </ng-template>
                                    <ng-template [ngIf]="!checkCurrentUser(person.personalnr) && isTeamLeader()">
                                        <div class="overflow-hidden text-nowrap text-overflow-ellipsis">
                                            <a [routerLink]="['/kalender', { id: person.personalnr, date: null }]">
                                                {{ person.name }}
                                            </a>
                                        </div>
                                    </ng-template>
                                </td>
                                <td *ngIf="TeamLeader" class="info-column-desktop" style="line-height: 14px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
                                    <span
                                        class="cursor-pointer text-blue-600 underline"
                                        role="button"
                                        tabindex="0"
                                        (click)="openEmployeeDocuments(person, $event)"
                                        [innerHTML]="person.info">
                                    </span>
                                </td>
                                <td *ngIf="!TeamLeader" style="line-height: 14px; width: 100%; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
                                    <ng-template [ngIf]="checkCurrentUser(person.personalnr)">
                                        <b>{{ person.name }}</b> {{ person.info }}
                                    </ng-template
                                    >
                                    <ng-template [ngIf]="!checkCurrentUser(person.personalnr)"
                                    >{{ person.name }} {{ person.info }}
                                    </ng-template
                                    >
                                </td>
                                <td class="w-status-column" style="border-right: 3px solid black !important">
                                    <fa-icon
                                            icon="circle"
                                            [style.color]="getPersonColor(person.personalnr)"
                                            [matTooltip]="getPersonTooltip(person.personalnr, person.info)"
                                            matTooltipClass="text-base multiline-tooltip"
                                            matTooltipPosition="after">
                                    </fa-icon>
                                </td>
                            </tr>
                        </ng-template>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="scrollable">
                <table class="calendar-data" id="headerdaymonth">
                    <thead>
                    <tr class="month">
                        <ng-template ngFor let-month [ngForOf]="myCalendarRange?.month">
                            <th *ngIf="month[2] > 5" [colSpan]="month[2]" class="month">{{ month[0] }} {{ month[1] }}
                            </th>
                            <th *ngIf="month[2] <= 5" [colSpan]="month[2]" class="month"></th>
                        </ng-template>
                    </tr>
                    <tr class="days">
                        <ng-template ngFor let-days [ngForOf]="myCalendarRange?.days" [ngForTrackBy]="trackByFn">
                            <!--check if weekend and first date of month -->
                            <th
                                    *ngIf="(days[1] == 'Sa' || days[1] == 'So') && days[0] == '01'"
                                    [ngClass]="{ today: days[4] == true, 'txc-cal-specialdaycolor': isSpecialDay(formatDate(days)) }"
                                    id="mon-{{ days[2] }}-{{ days[3] }}">
									<span>{{ days[0] }}</span
                                    >{{ days[1] }}
                            </th>
                            <!--check if weekend and not first date of month -->
                            <th
                                    *ngIf="(days[1] == 'Sa' || days[1] == 'So') && days[0] != '01'"
                                    [ngClass]="{ today: days[4] == true, 'txc-cal-specialdaycolor': isSpecialDay(formatDate(days)) }">
									<span>{{ days[0] }}</span
                                    >{{ days[1] }}
                            </th>
                            <!--check if not weekend and first date of month -->
                            <th
                                    *ngIf="days[1] != 'Sa' && days[1] != 'So' && days[0] == '01'"
                                    [ngClass]="{ today: days[4] == true, 'txc-cal-specialdaycolor': isSpecialDay(formatDate(days)) }"
                                    id="mon-{{ days[2] }}-{{ days[3] }}">
									<span>{{ days[0] }}</span
                                    >{{ days[1] }}
                            </th>
                            <!--check if not weekend and not first date of month -->
                            <th
                                    *ngIf="days[1] != 'Sa' && days[1] != 'So' && days[0] != '01'"
                                    [ngClass]="{ today: days[4] == true, 'txc-cal-specialdaycolor': isSpecialDay(formatDate(days))}">
									<span>{{ days[0] }}</span
                                    >{{ days[1] }}
                            </th>
                        </ng-template>
                    </tr>
                    </thead>
                </table>
                <div class="table-overflow" [style.max-height]="getMaxHeight()" id="calendardatatable" (scroll)="onScrollCalendar($event)">
                    <table>
                        <tbody>
                        <ng-template
                                ngFor
                                let-person
                                [ngForOf]="
									myCalendarRange?.persons
										| groupFilter:WfGroups:groupFilterTrigger
								"
                                [ngForTrackBy]="trackByFn">
                            <tr>
                                <ng-template ngFor let-calentry let-i="index" [ngForOf]="person.data">
                                    <td
                                            *ngIf="calentry.isError === 1 && person.personalnr === currentPersoId"
                                            [style.backgroundColor]="calentry.fehlzeit_color"
                                            [routerLink]="['/kalender', { id: null, date: (calentry.datum | formatTime: 'YYYY-MM-DD') }]"
                                            [style.boxShadow]="'inset 1px 1px 0 red, inset -1px -1px 0 red'"
                                            [style.cursor]="'pointer'"
                                            [attr.class]="calentry.todayClass"
                                            [attr.title]="calentry.fehlzeit_name + ' ' + (calentry.datum | formatTime: 'DD.MM.YYYY')">
                                        <ng-template [ngIf]="calentry.table_text != null">
                                            {{ calentry.table_text }}
                                        </ng-template>
                                    </td>
                                    <td
                                            *ngIf="calentry.isError === 1 && person.personalnr !== currentPersoId"
                                            [style.backgroundColor]="calentry.fehlzeit_color"
                                            [routerLink]="[
												'/kalender',
												{ id: person.personalnr, date: (calentry.datum | formatTime: 'YYYY-MM-DD') }
											]"
                                            [style.boxShadow]="'inset 1px 1px 0 red, inset -1px -1px 0 red'"
                                            [style.cursor]="'pointer'"
                                            [attr.class]="calentry.todayClass"
                                            [attr.title]="calentry.fehlzeit_name + ' ' + (calentry.datum | formatTime: 'DD.MM.YYYY')">
                                        <ng-template [ngIf]="calentry.table_text != null">
                                            {{ calentry.table_text }}
                                        </ng-template>
                                    </td>
                                    <td
                                            *ngIf="calentry.isError !== 1"
                                            [style.backgroundColor]="calentry.fehlzeit_color"
                                            [attr.class]="calentry.todayClass"
                                            [attr.title]="calentry.fehlzeit_name + ' ' + (calentry.datum | formatTime: 'DD.MM.YYYY')">
                                        <ng-template [ngIf]="calentry.table_text != null">
                                            {{ calentry.table_text }}
                                        </ng-template>
                                    </td>
                                </ng-template>
                            </tr>
                        </ng-template>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>
